/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import Swal from 'sweetalert2'
import { Button } from 'react-bootstrap'
import { getRequestOptions, postRequestOptions } from '../helpers/Fetchwrapper'
import validationErrorMsg from '../helpers/ValidationErrorMsg'
import Select from 'react-select'
import { Table } from 'react-bootstrap-v5'
import { useHistory, useParams, useLocation } from 'react-router-dom'
import { KTSVG } from '../../_metronic/helpers'
import ItemBomCreateModal from '../components/ItemBomCreateModal'

interface RouteParams {
	id: string;
}

interface InitialState {
	idItems: number;
	itemName: string;
	itemCode: string;
	unitName: string;
	quantityLtr: number | '';
	weightKg: number | '';
	remarks: string;
}

interface FormulationItem {
	idItemBomFormulations: number | null;
	idFormulationItems: number | null;
	itemName: string;
	categoryName: string;
	unitName: string;
	percentage: number | '';
	[key: string]: any;
}

interface ItemBomOption {
	label: string;
	value: number;
}

const emptyFormulationRow = (): FormulationItem => ({
	idItemBomFormulations: null,
	idFormulationItems: null,
	itemName: '',
	categoryName: '',
	unitName: '',
	percentage: '',
})

function ItemBomFormulation() {
	const history = useHistory()
	const location = useLocation()
	const { id }: RouteParams = useParams()
	const [productionItems, setProductionItems] = useState<any[]>([])
	const initialState: InitialState = {
		idItems: 0,
		itemName: '',
		itemCode: '',
		unitName: '',
		quantityLtr: '',
		weightKg: '',
		remarks: '',
	}

	const [formulationItems, setFormulationItems] = useState<FormulationItem[]>([emptyFormulationRow()])
	const [item, setItem] = useState(initialState)
	const [itemBomOptions, setItemBomOptions] = useState<ItemBomOption[]>([])
	const [selectedBom, setSelectedBom] = useState<ItemBomOption | null>(null)
	const [showBomCreateModal, setShowBomCreateModal] = useState(false)

	useEffect(() => {
		getAllProductionItems()
		getItemBoms(id)
	}, [])

	useEffect(() => {
		if (selectedBom?.value) {
			getItemBomFormulationData(id, selectedBom.value)
		}
	}, [selectedBom])

	const getItemBoms = (idItems: string) => {
		fetch(
			process.env.REACT_APP_API_URL + 'item-boms/' + idItems,
			getRequestOptions()
		)
			.then((resp) => resp.json())
			.then((resp) => {
				const options: ItemBomOption[] = (resp.data || []).map((bom: any) => ({
					label: bom.bom_name,
					value: bom.id_item_boms,
				}))
				setItemBomOptions(options)

				const query = new URLSearchParams(location.search)
				const idItemBomFromUrl = query.get('id_item_bom')
				const selected = idItemBomFromUrl
					? options.find((option) => option.value === Number(idItemBomFromUrl))
					: null
				const bomToSelect = selected || options[0] || null

				setSelectedBom(bomToSelect)
				if (bomToSelect && !idItemBomFromUrl) {
					history.replace(`/item-bom-formulation/${id}?id_item_bom=${bomToSelect.value}`)
				}
			})
			.catch((error) => {
				console.log(error, 'catch the hoop')
			})
	}

	const handleBomChange = (option: ItemBomOption | null) => {
		if (!option) {
			return
		}
		setSelectedBom(option)
		history.replace(`/item-bom-formulation/${id}?id_item_bom=${option.value}`)
	}

	const handleBomCreated = (newBomId: number, bomName: string) => {
		const newOption: ItemBomOption = { label: bomName, value: newBomId }
		setItemBomOptions((prev) => [...prev, newOption])
		setSelectedBom(newOption)
		history.replace(`/item-bom-formulation/${id}?id_item_bom=${newBomId}`)
	}

	const getItemBomFormulationData = (idItems: string, idItemBoms: number) => {
		fetch(
			process.env.REACT_APP_API_URL + 'item-bom-formulations/' + idItems + '?id_item_bom=' + idItemBoms,
			getRequestOptions()
		)
			.then((resp) => {
				return resp.json()
			})
			.then((resp) => {
				setItem({
					idItems: resp.data.idItems,
					itemName: resp.data.itemName || '',
					itemCode: resp.data.itemCode || '',
					unitName: resp.data.unitName || '',
					quantityLtr: resp.data.quantityLtr === null || resp.data.quantityLtr === undefined || resp.data.quantityLtr === ''
						? ''
						: parseFloat(resp.data.quantityLtr),
					weightKg: resp.data.weightKg === null || resp.data.weightKg === undefined || resp.data.weightKg === ''
						? ''
						: parseFloat(resp.data.weightKg),
					remarks: resp.data.remarks || '',
				})
				const transformedItems = (resp.items || []).map((row: any) => {
					const percentage = row.percentage === null || row.percentage === undefined || row.percentage === ''
						? ''
						: parseFloat(row.percentage)
					return {
						...row,
						percentage: percentage === 0 ? '' : percentage,
					}
				})
				setFormulationItems(transformedItems.length ? transformedItems : [emptyFormulationRow()])
			})
			.catch((error) => {
				console.log(error, 'catch the hoop')
			})
	}

	const getAllProductionItems = () => {
		fetch(
			process.env.REACT_APP_API_URL + 'allProductionItems',
			getRequestOptions()
		)
			.then((resp) => {
				return resp.json()
			})
			.then((resp) => {
				const items = resp.map((row: any) => {
					row.label = row.item_name
					row.categoryName = row.category_name
					row.value = row.id_items
					return row
				})
				setProductionItems(items)
			})
			.catch((error) => {
				console.log(error, 'catch the hoop')
			})
	}

	const totalPercentage = formulationItems.reduce((sum, row) => sum + (parseFloat(String(row.percentage)) || 0), 0)

	const saveItemBomFormulation = async (event: any) => {
		event.preventDefault()
		if (!selectedBom?.value) {
			Swal.fire({ icon: 'warning', title: 'Validation', text: 'Please select a BOM before saving.' })
			return
		}
		if (Math.round(totalPercentage * 100) / 100 !== 100) {
			Swal.fire({ icon: 'warning', title: 'Validation', text: 'Percentage must be 100' })
			return
		}
		const confirm = await Swal.fire({
			title: 'Are you sure?',
			text: 'You want to save this formulation?',
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#ec008c',
			cancelButtonText: 'Cancel',
			confirmButtonText: 'Yes, Save it!',
		})
		if (confirm.value) {
			const requestOptions = postRequestOptions({
				items: formulationItems,
				idItemBoms: selectedBom.value,
				quantityLtr: item.quantityLtr === '' ? null : item.quantityLtr,
				weightKg: item.weightKg === '' ? null : item.weightKg,
				remarks: item.remarks,
			})
			try {
				const response = await fetch(
					`${process.env.REACT_APP_API_URL}item-bom-formulations/${id}`,
					requestOptions
				)
				const respData = await response.json()
				if (respData.success === true) {
					Swal.fire({
						icon: 'success',
						title: 'Success',
						text: respData.successMessage,
					})
				} else {
					const errorsMessage = validationErrorMsg(respData.errors).join('<br>')
					Swal.fire({
						icon: 'error',
						title: 'Error',
						html: errorsMessage,
					})
				}
			} catch (error) {
				console.log(error, 'catch the hoop')
			}
		}
	}

	const addItem = () => {
		setFormulationItems([...formulationItems, emptyFormulationRow()])
	}

	const handleItemChange = (data: any, index: number) => {
		if (!data) {
			return
		}
		const updatedItems = [...formulationItems]
		updatedItems[index].idFormulationItems = data.value
		updatedItems[index].categoryName = data.categoryName
		updatedItems[index].unitName = data.unit_name
		setFormulationItems(updatedItems)
	}

	const handleItemDataChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
		const updatedItems = [...formulationItems]
		const { value } = e.target
		if (value === '') {
			updatedItems[index].percentage = ''
		} else {
			let percentage = parseFloat(value) || 0
			if (percentage > 100) percentage = 100
			if (percentage < 0) percentage = 0
			updatedItems[index].percentage = percentage
		}
		setFormulationItems(updatedItems)
	}

	const handleHeaderChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		const { name, value } = e.target
		setItem((prev) => ({ ...prev, [name]: value }))
	}

	const deleteItem = (index: number) => {
		const updatedItems = [...formulationItems]
		if (updatedItems && updatedItems[index]) {
			updatedItems.splice(index, 1)
			setFormulationItems(updatedItems)
		}
	}

	return (
		<div className="card card-custom">
			<div className="card-header">
				<div className="card-title">
					<KTSVG path="/media/svg/icons/Text/Bullet-list.svg" className="svg-icon-1 svg-icon-primary" />
					<span className="text fw-bolder" style={{ marginLeft: '10px' }}>
						Item BOM Formulation
					</span>
				</div>
			</div>

			<div className="card-body">
				<form onSubmit={saveItemBomFormulation}>
					<Table size="sm" bordered hover>
						<tbody>
							<tr>
								<td width={'30%'}>Item Name </td>
								<td width={'70%'}> : {item.itemName}</td>
							</tr>
							<tr>
								<td>Item Code </td>
								<td> : {item.itemCode}</td>
							</tr>
							<tr>
								<td>Unit </td>
								<td> : {item.unitName}</td>
							</tr>
							<tr>
								<td>Quantity (Ltr)</td>
								<td>
									<input
										type="number"
										name="quantityLtr"
										min={0}
										step="any"
										value={item.quantityLtr}
										onChange={handleHeaderChange}
										className="form-control"
										style={{ maxWidth: '200px', border: '1px solid #ced4da' }}
									/>
								</td>
							</tr>
							<tr>
								<td>Weight (KG)</td>
								<td>
									<input
										type="number"
										name="weightKg"
										min={0}
										step="any"
										value={item.weightKg}
										onChange={handleHeaderChange}
										className="form-control"
										style={{ maxWidth: '200px', border: '1px solid #ced4da' }}
									/>
								</td>
							</tr>
							<tr>
								<td>Remarks</td>
								<td>
									<textarea
										name="remarks"
										rows={3}
										value={item.remarks}
										onChange={handleHeaderChange}
										className="form-control"
										style={{ maxWidth: '500px', border: '1px solid #ced4da' }}
									/>
								</td>
							</tr>
							<tr>
								<td colSpan={2} className="text-end">
									<span className="d-inline-block me-2" style={{ minWidth: '220px', textAlign: 'left' }}>
										<Select
											value={selectedBom}
											onChange={(option: ItemBomOption | null) => handleBomChange(option)}
											options={itemBomOptions}
											placeholder="Select BOM"
											menuPosition="fixed"
											styles={{
												control: (provided) => ({
													...provided,
													height: '32px',
													minHeight: '32px',
												}),
												container: (provided) => ({
													...provided,
													height: '32px',
												}),
											}}
										/>
									</span>
									<Button type="button" variant="primary" size="sm" className="me-2" onClick={() => setShowBomCreateModal(true)}>
										<i className="fa fa-plus"></i> Create New BOM
									</Button>
									<Button type="button" variant="success" size="sm" onClick={() => addItem()}>
										<i className="fa fa-plus"></i> Add Item
									</Button>
								</td>
							</tr>
						</tbody>
					</Table>

					<Table size="sm" bordered hover>
						<thead>
							<tr>
								<th className="col-5">Item</th>
								<th className="col-3">Category</th>
								<th className="col-3">Percentage</th>
								<th className="col-1">Action</th>
							</tr>
						</thead>
						<tbody>
							{formulationItems.map((formulationItem, index) => (
								<tr key={'item' + index}>
									<td className="text-left">
										<Select
											value={productionItems.find((option) => option.value === formulationItems[index].idFormulationItems)}
											onChange={(selectedOption) => handleItemChange(selectedOption, index)}
											options={productionItems}
											className="sm"
											menuPosition="fixed"
											styles={{
												control: (provided) => ({
													...provided,
													height: '32px',
													minHeight: '32px',
												}),
												container: (provided) => ({
													...provided,
													height: '32px',
												}),
											}}
										/>
									</td>
									<td>{formulationItem.categoryName}</td>
									<td>
										<input
											type="number"
											name="percentage"
											min={0}
											max={100}
											step="any"
											value={formulationItem.percentage === 0 || formulationItem.percentage === '' || formulationItem.percentage == null ? '' : formulationItem.percentage}
											onChange={(event) => handleItemDataChange(event, index)}
											className="form-control form-control-sm"
										/>
									</td>
									<td>
										<button type="button" className="btn btn-light-primary btn-sm px-2 py-1" onClick={() => deleteItem(index)}>
											<KTSVG path="/media/svg/icons/General/Trash.svg" className="svg-icon-5 svg-icon-danger me-0" />
										</button>
									</td>
								</tr>
							))}
							<tr>
								<td className="text-end" colSpan={2}><b>Total : </b></td>
								<td><b>{totalPercentage.toFixed(2)}</b></td>
								<td></td>
							</tr>
						</tbody>
					</Table>

					<div className="form-group row">
						<div className="col text-center">
							<button type="submit" className="btn btn-sm btn-primary me-2"><span>  Save</span></button>
							<Button variant="secondary" size="sm" onClick={() => history.goBack()}>
								Close
							</Button>
						</div>
					</div>
				</form>
			</div>

			<ItemBomCreateModal
				show={showBomCreateModal}
				handleClose={() => setShowBomCreateModal(false)}
				item={{ idItems: Number(id), itemName: item.itemName }}
				onCreated={handleBomCreated}
				existingBoms={itemBomOptions}
			/>
		</div>
	)
}

export default ItemBomFormulation
